<template>
  <div class="acomodar">
    <div class="container-fluid py-4 px-4">
      <div v-if="!cubo">
        <button
          v-if="preguntas"
          class="btn btn-danger ms-2 my-2"
          @click="retroceder"
        >
          <i class="bi bi-skip-backward"></i>
        </button>

        <button
          v-if="!preguntas"
          class="btn btn-danger ms-2 my-2"
          @click="regreso"
        >
          <i class="bi bi-skip-backward"></i>
        </button>

        <button @click="PdfCapacitacion" class="btn btn-success ms-2 my-2">
          <i class="bi bi-file-earmark-pdf"></i>
        </button>

        <div class="border border-1 rounded-3 p-3 mb-2">
          <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
            <i class="bi bi-person-video display-4 text-primary"></i>
            <div>
              <p
                class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase"
              >
                ETAPA DE CAPACITACIONES SST
              </p>
              <p class="mb-0 tituloResaltado fs-4 fw-bold">DATOS GENERALES</p>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row g-2 mb-2">
            <div class="col-12 col-md-1">
              <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                <p class="mb-0 ps-2 color">EMPRESA :</p>
                <label class="ms-2 letras" disabled> {{ empresa }}</label>
              </div>
            </div>

            <div class="col-12 col-md-2">
              <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                <p class="mb-0 ps-2 color">CENTRO DE COSTO :</p>
                <label class="ms-2 letras" disabled> {{ centro }}</label>
              </div>
            </div>

            <div class="col-12 col-md-2">
              <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                <p class="mb-0 ps-2 color">SUB CENTRO DE COSTO :</p>
                <label class="ms-2 letras" disabled> {{ subCentro }}</label>
              </div>
            </div>

            <div class="col-12 col-md-2">
              <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                <p class="mb-0 ps-2 color">SUB SUBCENTRO :</p>
                <label class="ms-2 letras" disabled> {{ subSubCentro }}</label>
              </div>
            </div>

            <div class="col-12 col-md-1">
              <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                <p class="mb-0 ps-2 color">NOMBRE :</p>
                <label class="ms-2 letras" disabled> {{ nombre }}</label>
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                <p class="mb-0 ps-2 color">APELLIDO PATERNO :</p>
                <label class="ms-2 letras" disabled> {{ paterno }}</label>
              </div>
            </div>

            <div class="col-12 col-md-2">
              <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                <p class="mb-0 ps-2 color">APELLIDO MATERNO :</p>
                <label class="ms-2 letras" disabled> {{ materno }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
          <p class="text-center mb-0 letras">INTENTOS PERMITIDOS : 5</p>
          <p class="text-center mb-0 letras">
            LAS CAPACITACIONES SE INICIARON: El {{ respuesta }}
          </p>
          <p class="text-center mb-0 letras">
            METODO DE CALIFICACION: Calificación más alta
          </p>

        <div  class="text-center mt-3">
          <b-button :disabled="!estadoCapacitacion" @click="$bvModal.show('modal-certificado')" variant="primary" size="lg">
            <i class="bi bi-file-earmark-check"></i> Ver constancia de Capacitación
          </b-button>
        </div>

        <!-- Modal con el Certificado directo -->
        <b-modal id="modal-certificado" title="CONSTANCIA DE CAPACITACIÓN" size="lg" scrollable hide-footer>
              <div class="text-center  mb-2">
            <b-button variant="success" size="md" @click="procesarDescarga" :disabled="isGeneratingPdf">
              <span v-if="isGeneratingPdf" class="spinner-border spinner-border-sm me-2"></span>
              <i v-else class="bi bi-download me-2"></i> {{ isGeneratingPdf ? 'Generando...' : 'Descargar Constancia' }}
            </b-button>
          </div>
          <div  ref="certificado" class="document-container">
              <img v-if="idEmpresa" :src="require(`@/assets/Empresas/${idEmpresa}.png`)" alt="Logo" style="width: 180px" />

            <div class="contenido-certificado mt-5">
              <h1 class="titulo-cert text-center text-uppercase">CONSTANCIA DE CAPACITACIÓN</h1>
              
              <p class="marco-legal mt-4 mx-5 px-5">
                <span class="nombre-empresa">{{ empresa }}</span> bajo el marco de la ley 29783 y D.S. 005-2012 TR de Seguridad y Salud en el Trabajo deja constancia que:
              </p>
              
              <h4 class="nombre-empleado text-center mt-5">{{ nombre }} {{ paterno }} {{ materno }}</h4>
              
              <p class="texto-participacion mt-5 mx-5 px-5">
                Participó satisfactoriamente en la inducción y las capacitaciones en Seguridad y Salud en el Trabajo, desarrollada el día <b> {{ fechaInicioFormateada }}</b>, con una duración total de 02 horas, abordándose los siguientes temas:
              </p>
              
              <div class="curso-nombre text-start mt-2 ms-5 px-4">
                <div class="mt-2 mx-4" v-for="(curso, index) in des[0].titulo" :key="index">
                  - {{ curso }}
                </div>
              </div>
              
              <div class="footer mt-5 pt-4 text-end mb-0">
                <p class="me-3">Lima, {{ fechaInicioFormateada }}</p>
                <img  class="" style="width: 260px;" src="../../../../assets/FirmaSello/FIRMASELLO.png" alt="">
              </div>
            </div>
          </div>

      
        </b-modal>

          <div v-if="preguntas" class="px pt-2">
            <div class="row gx-4 gy-4">
              <div
                v-for="(capacitacion, index) in des[0].titulo"
                :key="index.id"
                class="col-12 col-md-6 col-lg-4 col-xl-3"
              >
                <!-- {{des[0].cabeceraVideo[index]}} -->

                <!-- <p v-if="nota[index] == des[0].cabeceraVideo[index]"></p>   -->
                <div
                  class="card shadow-sm h-100 p-3 d-flex flex-column justify-content-between"
                >
                  <p v-if="apagado">cargando....</p>

                  <!-- TÍTULO -->
                  <h6 class="fw-bold mb-2 text-center">
                    {{ capacitacion }}
                  </h6>

                  <!-- FORMATO A LA DERECHA + ICONO -->
                  <div class="d-flex align-items-center mb-2">
                    <span
                      class="tituloColor ms-auto d-flex align-items-center gap-2"
                    >
                      RESULTADO DE EXAMEN:
                      <i class="bi bi-box-arrow-down text-primary fs-7"></i>
                    </span>
                  </div>

                  <!-- BOTONES + NOTA -->
                  <div class="d-flex align-items-center gap-2 mb-3">
                    <!-- ▶ Botón YouTube pequeño -->
                    <a
                      v-if="!apagado"
                      :href="des[0].linksVideo[index]"
                      target="_blank"
                      class="btn btn-outline-danger d-flex align-items-center justify-content-center px-3 py-2"
                    >
                      <i class="bi bi-youtube fs-4"></i>
                    </a>

                    <!-- 📝 Botón Examen -->
                    <button
                      v-if="
                        !botonPregunta &&
                        (permisoVisualizador == 2 || permisoVisualizador == 11)
                      "
                      class="btn btn-outline-primary d-flex align-items-center justify-content-center px-3 py-2"
                      @click="
                        EnviarPreguntas(
                          des[0].cabeceraVideo[index],
                          capacitacion
                        )
                      "
                    >
                      <i class="bi bi-clipboard-check fs-4"></i>
                    </button>

                    <!-- 🔄 Cargando -->
                    <button
                      v-if="botonPregunta"
                      :disabled="botonPregunta"
                      class="btn btn-success px-3 py-2"
                    >
                      Cargando…
                    </button>

                    <!-- NOTA - AL COSTADO DERECHO -->
                    <div class="ms-auto">
                      <!-- Escritorio -->
                      <span
                        v-if="!isMobile"
                        class="btn btn-light border border-2 tamaño-nota text-dark text-end"
                      >
                        {{ nota[index] }}
                      </span>

                      <!-- Móvil -->
                      <span
                        v-if="isMobile"
                        class="btn btn-light border border-2 tamaño-nota text-dark w-100 text-end"
                      >
                        {{ nota[index] }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered letras mt-5">
                <thead class="bg-solimano text-white">
                  <tr class="text-center">
                    <th scope="col">ID</th>
                    <th scope="col">TEMA</th>
                    <th scope="col">NOTA</th>
                    <th scope="col">INTENTO</th>
                    <th scope="col">FECHA/HORA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="info in infex" :key="info.id">
                    <td class="text-center">
                      <i class=""></i>{{ info.idVideo }}
                    </td>
                    <td class="text-center">
                      <i class="bi bi-journal-text me-1"></i>{{ info.nombre }}
                    </td>
                    <td class="text-center">
                      <i class="bi bi-star-fill text-warning me-1"></i
                      >{{ info.nota }}
                    </td>
                    <td class="text-center">
                      <i class="bi bi-arrow-repeat me-1"></i>{{ info.intento }}
                    </td>
                    <td class="text-center">
                      <i class="bi bi-calendar me-1"></i>{{ info.fecha }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-else class="pt-3 mb-5">
            <div class="pt-3 mb-5">
              <!-- <button v-if="spinner" @click="apreder">aplicar</button> -->
              <div>
                <h3 class="mt-3 titulo2">{{ tituloCapacitacion }}</h3>
              </div>
              <!-- <p v-if="spinner">cargando....</p> -->

              <form action="" @submit.prevent="eventos">
                <div
                  class="d-flex"
                  v-for="(items, index) in apiPregunta"
                  :key="index.id"
                >
                  <input
                    type="checkbox"
                    class="mt-3 mx-2"
                    :value="items.idDetVideo"
                    @change="preguntasMarcada(items.nroPregunta)"
                    v-model="picked1"
                    v-if="items.alternativa != 0"
                  />

                  <label
                    class="mt-4 tamaño2"
                    :class="{ tamaño: items.alternativa == 0 }"
                  >
                    {{ items.vidPreguntaDes }}
                  </label>
                </div>

                <button
                  type="submit"
                  class="btn btn-success mt-5"
                  :disabled="TiempoDeCarga"
                >
                  <i class="bi bi-floppy"></i>
                  GUARDAR RESPUESTA
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Spinner v-if="cubo" class="w-100"></Spinner>

      <div v-if="mensaje" class="container mt-5 w-100">
        <h3 class="text-center mt-3">No hay videos Disponibles...</h3>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import Spinner from "@/views/SpinnerCarga/Spinner.vue";
import Swal from "sweetalert2";
// import VueYoutube from 'vue-youtube';
import { saveAs } from "file-saver";

export default {
  name: "SolimanologDatosCapacitacion",
  components: {
    Spinner,
    //  VueYoutube
  },

  data() {
    return {
      mensaje: false,
      cubo: true,
      TiempoDeCarga: false,
      preguntas: true,
      apagado: true,
      spinner: true,
      items: [],
      titulo: [],
      videosUrl: [],
      pregunta: [],
      cabeceraId: [],
      tituloCapacitacion: "",
      des: [
        {
          titulo: [],
          linksVideo: [],
          nombreVideo: [],
          numeroPregunta: [],
          cabeceraVideo: [],
        },
      ],
      isdisabled: true,
      picked1: [],
      preguntara: [],
      nota: [],
      botonPregunta: true,

      form: {
        idUsuario: "",
        idSolxPostulante: "",
        idCabVideo: "",
        vidPreNumero: "",
        detVideo: "",
      },
      apiPregunta: [],
      preguntasResponder: [],
      permisoVisualizador: null,
      numero: [],

      nombre: "",
      paterno: "",
      materno: "",
      empresa: "",
      centro: "",
      subCentro: "",
      subSubCentro: "",
      respuesta: [],
      infex: [],
      isGeneratingPdf: false, // Nuevo estado para el spinner
      pdfPreviewUrl: null, // Para la URL del PDF generado

      isMobile: false,
      renderizarCertificado: false, // Controla que no se vea en la pantalla
      mostrar : false,
      idEmpresa:"",
      estadoCapacitacion:Boolean,
      fechaInicioContrato:""
    };
  },

  async mounted() {
    // for (let iteracion of this.des[0].cabeceraVideo) {
    //   await this.axios
    //     .get(
    //       `VidCapacitacion/ObtenerNotas?idSolxPostulante=${this.$route.params.idSol}&idVideo=${iteracion}`
    //     )
    //     .then((r) => {
    //       this.nota.push(r.data);
    //     });
    // }

    this.obtenerDatosContra();
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },

  beforeDestroy() {
    // Revocar la URL del blob para liberar memoria cuando el componente se destruye
    if (this.pdfPreviewUrl) {
      URL.revokeObjectURL(this.pdfPreviewUrl);
    }
  },
  async created() {
    this.form.idUsuario = localStorage.getItem("userId");
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.form.idSolxPostulante = this.$route.params.idSol;

    await this.axios
      .get("VidCapacitacion/CapxPostulante/" + this.$route.params.idSol)
      .then((r) => {
        console.log('gente' ,r.data);
        if (r.data.length == 0) {
          this.mensaje = true;
          this.cubo = false;
        }
        this.botonPregunta = false;

        this.items = r.data;
        this.apagado = false;
        for (let itema of r.data) {
          this.titulo.push(itema.nomVideo);
          this.videosUrl.push(itema.videolink);
          this.pregunta.push(itema.numPregunta);
          this.cabeceraId.push(itema.idCabVideo);

          this.des[0].titulo = this.titulo.filter((item, index) => {
            return this.titulo.indexOf(item) === index;
          });

          this.des[0].linksVideo = this.videosUrl.filter((item, index) => {
            return this.videosUrl.indexOf(item) === index;
          });

          this.des[0].numeroPregunta = this.pregunta.filter((item, index) => {
            return this.pregunta.indexOf(item) === index;
          });

          this.des[0].cabeceraVideo = this.cabeceraId.filter((item, index) => {
            return this.cabeceraId.indexOf(item) === index;
          });
        }
      });

    this.Notas();

    this.Informacion();

  },

  watch: {
    index: function () {
      // Cambiar el video cuando cambia el índice
      // Esto asume que `linksVideo` es un array de ID de video de YouTube
      this.$refs.youtubePlayer.play();
    },
  },

  computed: {
    fechaInicioFormateada() {
      if (!this.fechaInicioContrato) return "";

      // Obtenemos solo la parte YYYY-MM-DD (primeros 10 caracteres)
      const fechaBase = this.fechaInicioContrato.substring(0, 10);
      const partes = fechaBase.split("-");

      if (partes.length !== 3) return this.fechaInicioContrato;

      const meses = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
      ];

      const anio = partes[0];
      const mes = meses[parseInt(partes[1]) - 1];
      const dia = partes[2];

      return `${dia} de ${mes} del ${anio}`;
    }
  },

  methods: {
    PdfCapacitacion() {
      const url = "Renovacion/GenerarpdfSst?idSolxPostulante=1";

      this.axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          saveAs(blob, "nombre_del_archivo.pdf");
          console.log(response);
        })
        .catch((error) => {
          console.error("Error al descargar el PDF", error);
        });
    },

    async procesarDescarga() {
      this.isGeneratingPdf = true;
      const element = this.$refs.certificado;
      
      const opt = {
        margin: [1, 1, 1, 1],
        filename: `Certificado_${this.nombre.replace(/\s+/g, '_')}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' }
      };

      try {
        await html2pdf().set(opt).from(element).save();
        Swal.fire({
          icon: 'success',
          title: 'Descarga exitosa',
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error) {
        console.error("Error al procesar el PDF:", error);
      } finally {
        this.isGeneratingPdf = false;
      }
    },

    onPlaying() {
      console.log("Video started playing");
      // Puedes realizar acciones adicionales cuando el video comienza a reproducirse
    },
    onPaused() {
      console.log("Video paused");
      // Puedes realizar acciones adicionales cuando el video se pausa
    },

    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Ajusta el ancho según tus necesidades
    },
    Informacion() {
      this.axios
        .get(
          `VidCapacitacion/ListarNotas?idSolxPostulante=${this.$route.params.idSol}`
        )
        .then((r) => {
          console.log(r);
          this.respuesta = r.data[0].fecha;
          this.infex = r.data;
        });
    },
    obtenerDatosContra() {
      this.axios
        .get("Contrato/ObtenerDatosContrato/" + this.$route.params.idSol)
        .then((r) => {
          console.log('los datos',r.data);
          this.nombre = r.data[0].posNombre;
          this.paterno = r.data[0].posApellidoPaterno;
          this.materno = r.data[0].posApellidoMaterno;
          this.empresa = r.data[0].nomEmpresa;
          this.centro = r.data[0].centroCosto;
          this.subCentro = r.data[0].subCentroCosto;
          this.subSubCentro = r.data[0].subSubCentroCosto;
          this.idEmpresa = r.data[0].idEmpresa;
          this.fechaInicioContrato = r.data[0].fecIniContrato;
          this.estadoCapacitacion = r.data[0].estadoCapacitacion;
        });
    },

    async CambiarEstadoCapacitacion() {
      let idSolxPostulante = this.form.idSolxPostulante;
      let response = await this.axios.put(`VidCapacitacion/ModificarCapa`, {
        idSolxPostulante,
      });
      console.log(idSolxPostulante);
      console.log(response.data);
    },

    async Notas() {
      this.nota = [];
      for (let iteracion of this.des[0].cabeceraVideo) {
        await this.axios
          .get(
            `VidCapacitacion/ObtenerNotas?idSolxPostulante=${this.$route.params.idSol}&idVideo=${iteracion}`
          )
          .then((r) => {
            console.log(r.data);
            this.nota.push(r.data);
          });
        this.CambiarEstadoCapacitacion();
        if (this.nota.length == this.des[0].cabeceraVideo.length) {
          this.cubo = false;
        }
      }
    },

    retroceder() {
      window.history.back();
    },

    EnviarPreguntas(nroPregunta, titulo) {
      this.tituloCapacitacion = titulo;
      this.form.idCabVideo = nroPregunta;
      this.preguntas = false;
      this.axios
        .get(`VidCapacitacion/PreguntasxVideo/${this.form.idCabVideo}`)
        .then((r) => {
          this.apiPregunta = r.data;
          this.spinner = true;
        });
    },

    regreso() {
      this.cubo = true;
      this.Notas();
      this.preguntas = !this.preguntas;
      this.picked1 = [];
      this.preguntara = [];
      this.preguntasResponder = [];
      this.numero = [];
    },

    preguntasMarcada(event) {
      this.preguntara.push(event);
    },

    eventos() {
      this.TiempoDeCarga = true;
      let arreglo1 = this.preguntara.sort(function (a, b) {
        return a - b;
      });

      let arreglo2 = this.picked1.sort(function (a, b) {
        return a - b;
      });

      let array1 = arreglo1.filter((item, index) => {
        return arreglo1.indexOf(item) === index;
      });

      this.form.vidPreNumero = `${array1}`;
      this.form.detVideo = `${arreglo2}`;
      console.log(this.form.vidPreNumero);
      console.log(this.form.detVideo);

      for (let i of this.apiPregunta) {
        this.numero.push(i.nroPregunta);
      }

      let numeroPreguntas = Math.max(...this.numero);
      if (
        arreglo2.length == numeroPreguntas &&
        array1.length == numeroPreguntas
      ) {
        this.axios
          .post("VidCapacitacion/RegistrarRespuestas", this.form)
          .then((r) => {
            // this.Informacion()
            console.log(r.data);

            if (r.data == true) {
              // this.Notas()
              setTimeout(() => {
                this.TiempoDeCarga = false;
              }, 5000);
              Swal.fire({
                position: "center",
                icon: "success",
                title: "¡SE REGISTRARON SUS RESPUESTAS!",
                showConfirmButton: true,
              });
              this.picked1 = [];
              this.numero = [];
              location.reload();
            }
          });
      }

      if (arreglo2.length === 0 || arreglo2.length < numeroPreguntas) {
        Swal.fire({
          title: "¡SE DEBE REALIZAR TODAS LAS PREGUNTAS!",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });

        this.TiempoDeCarga = false;
      }

      if (
        arreglo2.length > numeroPreguntas ||
        this.form.vidPreNumero.length < numeroPreguntas
      ) {
        Swal.fire({
          title: "¡SE DEBE MARCAR UNO POR PREGUNTA!",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
        this.TiempoDeCarga = false;
      }
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 1%;
  margin-right: 1%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: none;
}

.document-container {
  background-color: white;
  padding: 0.1cm 0.5cm 0.1cm 0.5cm; /* Ajustado el padding superior para subir la imagen */
  margin: 0 auto;
  width: 100%;
  max-width: 21cm;
  /* min-height: 29.7cm; */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-family: 'Times New Roman', serif;
  color: black;
}

.titulo-cert { /* Este ya estaba bien */
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 1px;
  border-bottom: 2px solid #000; /* Subrayado elegante */
  display: table;
  margin: 0 auto;
}

/* Este bloque de estilos estaba suelto o mal asociado */
.nombre-empresa { /* Asumo que estos estilos eran para el nombre de la empresa "curveado" */
  font-size: 22px; /* Ajustado para que no sea tan pequeño como 0.65rem */
  font-weight: 600;
  font-style: italic;
}

.marco-legal { /* Añadido de nuevo, ya que es importante para el texto legal */
  font-size: 18px; /* Tamaño de fuente adecuado para texto legal */
  line-height: 1.6;
  text-align: justify;
}

.nombre-empleado { /* Añadido de nuevo para el nombre del empleado */
  font-size: 22px; /* Tamaño de fuente para el nombre del empleado */
  font-weight: bold;
  text-align: center;
}

.texto-participacion { /* Selector corregido */
  font-size: 18px; /* Tamaño de fuente adecuado */
  text-align: justify;
}

.curso-nombre { /* Selector corregido */
  font-size: 11.5px; /* Tamaño de fuente para los cursos */
  font-weight: 500;
  color: #000;
  padding: 12px;
  white-space: pre-line;
}

.footer { /* Selector corregido */
  font-size: 18px; /* Tamaño de fuente para el pie de página */
  font-weight: 600;
}

.titulo { /* Selector corregido, manteniendo el tamaño pequeño */
  font-size: 0.65rem;
}

.titulo2 {
  color: #0080c8;
  text-decoration: underline;
}

.img-fluid {
  height: auto;
}

.bg-solimano {
  background: #0080c8;
}

.preguntas {
  color: #002c5d;
  font-size: 1.05rem;
  font-weight: 600;
}

.tituloColor {
  font-weight: 500;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  color: #002c5d;
  font-size: 0.65rem;
}

.tamaño-nota {
  font-size: 0.65rem;
}

.tamaño {
  font-weight: 600;
  color: rgb(24, 83, 248);
}

.tamaño2 {
  font-size: 0.65rem;
}

.color {
  font-weight: 700;
  color: #002c5d;
  font-size: 0.65rem;
}

.letras {
  font-size: 0.65rem;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.iconoYutu {
  font-size: 5.24rem;
  margin: 0;
  padding: 0;
  /* Establece el relleno a cero */
}

.iconoeditar {
  font-size: 4.7rem;
}

.realizar {
  font-size: 0.95rem;
}
</style>
